const xSeries = [
  { width: 1125, height: 2436 }, // X && Xs
  { width: 828, height: 1792 }, // Xr
  { width: 1242, height: 2688 } // Xs Max
]

const engComAppCode = '9DF6'
const projectBoardAppCode = 'BF05'

const lib = {
  _cache: {},

  cache: function (key, callback) {
    if (typeof lib._cache[key] === 'undefined') {
      lib._cache[key] = callback()
    }

    return lib._cache[key]
  },

  isEdge: function () {
    return lib.cache('isEdge', () => !!navigator.userAgent.match(/Edge/)) // note: for legacy versions of Edge only
  },
  isSafari: function () {
    return window.safari !== undefined // note: this works only for browsers are not for mobile
  },
  isChrome: function () {
    return lib.cache('isChrome', () => !!navigator.userAgent.match(/Chrome/))
  },
  isIE11: function () {
    return lib.cache('isIE11', () => !!navigator.userAgent.match(/Windows.*rv:11\.0/))
  },
  isIOSChrome: function () {
    return lib.cache('isIOSChrome', () => !!navigator.userAgent.match(/CriOS/))
  },
  isIOS: function () {
    return lib.cache('isIOS', () => !!navigator.userAgent.match(/(iPod|iPhone|iPad)/))
  },
  isIOS11: function () {
    return lib.cache('isIOS11', () => lib.isIOS() && !!navigator.userAgent.match(/OS 11_/))
  },
  isMacOS: function () {
    return lib.cache('isMacOS', () => !!navigator.userAgent.match(/Mac OS X/))
  },
  isAndroid: function () {
    return lib.cache('isAndroid', () => !!navigator.userAgent.match(/Android/))
  },
  isApp: function () {
    return lib.cache('isApp', () => lib.isProjectBoardApp() || lib.isEngComApp())
  },
  isProjectBoardApp: function () {
    return lib.cache('isProjectBoardApp', () => !!navigator.userAgent.match(/ProjectBoardApp/))
  },
  isEngComApp: function () {
    return lib.cache('isEngComApp', () => !!navigator.userAgent.match(/EngComApp/))
  },
  isIOSApp: function () {
    return lib.cache('isIOSApp', () => (lib.isIOS() || lib.isIOS11()) && lib.isApp())
  },
  isAndroidApp: function () {
    return lib.cache('isAndroidApp', () => lib.isAndroid() && lib.isApp())
  },
  isAllMobile: function () {
    return lib.cache('isAllMobile', () => lib.isIOS() || lib.isIOS11() || lib.isAndroid() || lib.isApp())
  },
  isIphoneX: function () {
    return lib.cache('isIphoneX', () => {
      if (!lib.isIOS()) {
        return false
      }

      const ratio = window.devicePixelRatio || 1
      const screen = {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio
      }

      let match = false
      xSeries.forEach((x) => {
        match = match || (screen.width === x.width && screen.height === x.height)
      })

      return match
    })
  },
  isIpad: function () {
    // The user agent of Safari on iPadOS exactly the same as Safari on macOS. There's no official touch screen for Mac. The actual value of maxTouchPoints on the iPad is 5
    return navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2
  },
  projectBoardAppURI: function () {
    return 'com.engineering.projectboard.app'
  },
  engComAppURI: function () {
    return 'com.engineering.app'
  },
  appURI: function (code) {
    switch (code) {
      case projectBoardAppCode:
        return this.projectBoardAppURI()
      case engComAppCode:
        return this.engComAppURI()
      default:
        return this.isEngComApp() ? this.engComAppURI() : this.projectBoardAppURI()
    }
  },
  appCode: function () {
    return this.isEngComApp() ? engComAppCode : projectBoardAppCode
  }
}

export default lib
